<template>
  <div>
    <section class="page-content rx-page-application">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="mr-1">10A.</span>If you have less than 3 years experience, please describe your experience:
              </label>
              <input
                  type="text"
                  name="threeYearsExperience"
                  v-model="insuranceAgentApplication.threeYearsExperience"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('threeYearsExperience')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('threeYearsExperience') | filterText }}</span>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="mr-1">11.</span>Number of Non-Owner Employees:
              </label>
              <label for class="orep-label">
                <span class="mr-1">Full Time:</span>
              </label>
              <input
                  type="number"
                  name="nonEmployeesFulltime"
                  v-model="insuranceAgentApplication.nonEmployeesFulltime"
                  class="orep-text-input w-20"
                  @input="validateBeforeSubmit()"
              >
              <label for class="orep-label">
                <span class="mr-1">Part Time:</span>
              </label>
              <input
                  type="number"
                  name="nonEmployeesParttime"
                  v-model="insuranceAgentApplication.nonEmployeesParttime"
                  class="orep-text-input w-20"
                  @input="validateBeforeSubmit()"/>
            </article>
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">  PREMIUM WRITTEN AND COMMISSIONS </h1>
            </article>

            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-10">
                  <label for class="orep-label">
                    <span class="mr-1">12. </span>
                     Please list your written Premium and Commission for:
                  </label>
                </div>
              </div>
              <table class="w-100">
                <thead>
                <tr>
                  <th></th>
                  <th colspan="2">Last 12 Months</th>
                  <th colspan="2">Next 12 Months (Estimate)</th>
                </tr>
                </thead>
                <tbody>
                <th>
                  Premium:
                </th>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="periodOne"
                        name="periodOne"
                        v-model="insuranceAgentApplication.periodOne"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="periodTwo"
                        name="periodTwo"
                        v-model="insuranceAgentApplication.periodTwo"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                <tr>
                <th>
                  Commission:
                </th>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="estimateCommissionEarnOne"
                        name="estimateCommissionEarnOne"
                        v-model="insuranceAgentApplication.estimateCommissionEarnOne"
                        v-validate="'required'"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="estimateCommissionEarnTwo"
                        name="estimateCommissionEarnTwo"
                        v-model="insuranceAgentApplication.estimateCommissionEarnTwo"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                </tr>
                </tbody>
              </table>
            </article>

            <article class="input-section form-section">
              <label class="orep-label">
                <span class="mr-1">13. </span>Please list your Revenue by Line of Business:
              </label>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Commercial Fire & Inland Marine: </label>
                <input
                    type="number"
                    name="commercialFire"
                    v-model="insuranceAgentApplication.commercialFire"
                    class="orep-text-input ml-3 mr-1"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Commercial General / Excess Liab:  </label>
                <input
                    type="number"
                    name="commercialGeneral"
                    v-model="insuranceAgentApplication.commercialGeneral"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
                <span
                    v-show="errors.has('commercialGeneral')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('commercialGeneral') | filterText }}</span>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Non-Artisan Contractors GL: </label>
                <input
                    type="number"
                    name="nonArtisanContractors"
                    v-model="insuranceAgentApplication.nonArtisanContractors"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
                <span
                    v-show="errors.has('nonArtisanContractors')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('nonArtisanContractors') | filterText }}</span>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Commercial Auto / Garage / Dealers: </label>
                <input
                    type="number"
                    name="commercialAutoGarage"
                    v-model="insuranceAgentApplication.commercialAutoGarage"
                    class="orep-text-input ml-3 mr-1"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Trucking (Long Haul):  </label>
                <input
                    type="number"
                    name="truckingLongHaul"
                    v-model="insuranceAgentApplication.truckingLongHaul"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Worker's Comp:  </label>
                <input
                    type="number"
                    name="workersComp"
                    v-model="insuranceAgentApplication.workersComp"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">BOP: </label>
                <input
                    type="number"
                    name="bop"
                    v-model="insuranceAgentApplication.bop"
                    class="orep-text-input ml-3 mr-1"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Professional Liability:  </label>
                <input
                    type="number"
                    name="professionalLiability"
                    v-model="insuranceAgentApplication.professionalLiability"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Ocean Marine:  </label>
                <input
                    type="number"
                    name="oceanMarine"
                    v-model="insuranceAgentApplication.oceanMarine"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Aviation: </label>
                <input
                    type="number"
                    name="aviation"
                    v-model="insuranceAgentApplication.aviation"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Surety: </label>
                <input
                    type="number"
                    name="surety"
                    v-model="insuranceAgentApplication.surety"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Bonds other than Surety:  </label>
                <input
                    type="number"
                    name="bondsOtherThanSurety"
                    v-model="insuranceAgentApplication.bondsOtherThanSurety"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Homeowners / Dwelling Fire: </label>
                <input
                    type="number"
                    name="homeowners"
                    v-model="insuranceAgentApplication.homeowners"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Personal Auto:  </label>
                <input
                    type="number"
                    name="personalAuto"
                    v-model="insuranceAgentApplication.personalAuto"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Personal Floaters:  </label>
                <input
                    type="number"
                    name="personalFloaters"
                    v-model="insuranceAgentApplication.personalFloaters"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>
              <div class="d-flex align-items-center py-2"  >
                <label class="mb-0" style="width: 300px;">Life / Accident / Health / Group:  </label>
                <input
                    type="number"
                    name="lifeAccident"
                    v-model="insuranceAgentApplication.lifeAccident"
                    class="orep-text-input ml-3 mr-1"
                    @input="validateBeforeSubmit()"
                    style="width: 150px;"
                >
                <label class="mb-0 mr-4">%</label>
              </div>

              <label class="mb-0" style="width: 300px;">Other (Explain):  </label>
              <input
                  type="number"
                  name="otherExplain"
                  v-model="insuranceAgentApplication.otherExplain"
                  class="orep-text-input ml-3 mr-1"
                  @input="validateBeforeSubmit()"
                  style="width: 150px;"
              >
              <label class="mb-0 mr-4">%</label>
            </article>

            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">14. </span>
                    Are you engaged in any business other than your work as an insurance agent or broker?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="otherBusinessThanInsurance"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.otherBusinessThanInsurance"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="otherBusinessThanInsurance"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.otherBusinessThanInsurance"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('otherBusinessThanInsurance')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('otherBusinessThanInsurance') | filterText }}</span>
                </div>
              </div>
              <div class="row" style="margin-bottom: 20px;">
                <div class="col-md-9 col-sm-12">
                <div class="row" v-if="insuranceAgentApplication.otherBusinessThanInsurance == true || insuranceAgentApplication.otherBusinessThanInsurance === 'true'">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Program Manager:
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="programManager"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.programManager"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="programManager"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.programManager"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('programManager')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('programManager') | filterText }}</span>
                </div>
              </div>
                <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.programManager == true || insuranceAgentApplication.programManager === 'true'">
                <label class="orep-label text-danger">If Yes: Revenue:
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="insuranceAgentApplication.programManager == true || insuranceAgentApplication.programManager === 'true'"
                    name="programManagerRevenue"
                    v-model="insuranceAgentApplication.programManagerRevenue"
                    @input="validateBeforeSubmit()"
                >
              </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 20px;">
                <div class="col-md-9 col-sm-12">
                  <div class="row" v-if="insuranceAgentApplication.otherBusinessThanInsurance == true || insuranceAgentApplication.otherBusinessThanInsurance === 'true'">
                    <div class="col-md-9 col-sm-12">
                      <label for class="orep-label">
                        Managing General Agent:
                      </label>
                    </div>
                    <div class="col-md-3 d-flex flex-column">
                      <div class="d-flex flex-row">
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="managingGeneralAgent"
                                value="true"
                                class="orep-radio"
                                v-validate="'required'"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.managingGeneralAgent"
                            >
                            <span class="radio-span">Yes</span>
                          </label>
                        </div>
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="managingGeneralAgent"
                                value="false"
                                class="orep-radio"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.managingGeneralAgent"
                            >
                            <span class="radio-span">No</span>
                          </label>
                        </div>
                      </div>
                      <span
                          v-show="errors.has('managingGeneralAgent')"
                          class="help is-danger form-errors text-danger"
                      >{{ errors.first('managingGeneralAgent') | filterText }}</span>
                    </div>
                  </div>
                  <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.managingGeneralAgent == true || insuranceAgentApplication.managingGeneralAgent === 'true'">
                    <label class="orep-label text-danger">If Yes: Revenue:
                    </label>

                    <input
                        type="text"
                        placeholder="Please explain:"
                        class="orep-text-input js-orep-input"
                        v-if="insuranceAgentApplication.managingGeneralAgent == true || insuranceAgentApplication.managingGeneralAgent === 'true'"
                        name="managingGeneralAgentRevenue"
                        v-model="insuranceAgentApplication.managingGeneralAgentRevenue"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 20px;">
                <div class="col-md-9 col-sm-12">
                  <div class="row" v-if="insuranceAgentApplication.otherBusinessThanInsurance == true || insuranceAgentApplication.otherBusinessThanInsurance === 'true'">
                    <div class="col-md-9 col-sm-12">
                      <label for class="orep-label">
                        Tax Services:
                      </label>
                    </div>
                    <div class="col-md-3 d-flex flex-column">
                      <div class="d-flex flex-row">
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="taxServices"
                                value="true"
                                class="orep-radio"
                                v-validate="'required'"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.taxServices"
                            >
                            <span class="radio-span">Yes</span>
                          </label>
                        </div>
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="taxServices"
                                value="false"
                                class="orep-radio"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.taxServices"
                            >
                            <span class="radio-span">No</span>
                          </label>
                        </div>
                      </div>
                      <span
                          v-show="errors.has('taxServices')"
                          class="help is-danger form-errors text-danger"
                      >{{ errors.first('taxServices') | filterText }}</span>
                    </div>
                  </div>
                  <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.taxServices == true || insuranceAgentApplication.taxServices === 'true'">
                    <label class="orep-label text-danger">If Yes: Revenue:
                    </label>

                    <input
                        type="text"
                        placeholder="Please explain:"
                        class="orep-text-input js-orep-input"
                        v-if="insuranceAgentApplication.taxServices == true || insuranceAgentApplication.taxServices === 'true'"
                        name="taxServicesRevenue"
                        v-model="insuranceAgentApplication.taxServicesRevenue"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 20px;">
                <div class="col-md-9 col-sm-12">
                  <div class="row" v-if="insuranceAgentApplication.otherBusinessThanInsurance == true || insuranceAgentApplication.otherBusinessThanInsurance === 'true'">
                    <div class="col-md-9 col-sm-12">
                      <label for class="orep-label">
                        Bookkeeping:
                      </label>
                    </div>
                    <div class="col-md-3 d-flex flex-column">
                      <div class="d-flex flex-row">
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="bookKeeping"
                                value="true"
                                class="orep-radio"
                                v-validate="'required'"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.bookKeeping"
                            >
                            <span class="radio-span">Yes</span>
                          </label>
                        </div>
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="bookKeeping"
                                value="false"
                                class="orep-radio"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.bookKeeping"
                            >
                            <span class="radio-span">No</span>
                          </label>
                        </div>
                      </div>
                      <span
                          v-show="errors.has('bookKeeping')"
                          class="help is-danger form-errors text-danger"
                      >{{ errors.first('bookKeeping') | filterText }}</span>
                    </div>
                  </div>
                  <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.bookKeeping == true || insuranceAgentApplication.bookKeeping === 'true'">
                    <label class="orep-label text-danger">If Yes: Revenue:
                    </label>

                    <input
                        type="text"
                        placeholder="Please explain:"
                        class="orep-text-input js-orep-input"
                        v-if="insuranceAgentApplication.bookKeeping == true || insuranceAgentApplication.bookKeeping === 'true'"
                        name="bookKeepingRevenue"
                        v-model="insuranceAgentApplication.bookKeepingRevenue"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 20px;">
                <div class="col-md-9 col-sm-12">
                  <div class="row" v-if="insuranceAgentApplication.otherBusinessThanInsurance == true || insuranceAgentApplication.otherBusinessThanInsurance === 'true'">
                    <div class="col-md-9 col-sm-12">
                      <label for class="orep-label">
                        Adjusting Claims:
                      </label>
                    </div>
                    <div class="col-md-3 d-flex flex-column">
                      <div class="d-flex flex-row">
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="adjustingClaims"
                                value="true"
                                class="orep-radio"
                                v-validate="'required'"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.adjustingClaims"
                            >
                            <span class="radio-span">Yes</span>
                          </label>
                        </div>
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="adjustingClaims"
                                value="false"
                                class="orep-radio"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.adjustingClaims"
                            >
                            <span class="radio-span">No</span>
                          </label>
                        </div>
                      </div>
                      <span
                          v-show="errors.has('adjustingClaims')"
                          class="help is-danger form-errors text-danger"
                      >{{ errors.first('adjustingClaims') | filterText }}</span>
                    </div>
                  </div>
                  <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.adjustingClaims == true || insuranceAgentApplication.adjustingClaims === 'true'">
                    <label class="orep-label text-danger">If Yes: Revenue:
                    </label>

                    <input
                        type="text"
                        placeholder="Please explain:"
                        class="orep-text-input js-orep-input"
                        v-if="insuranceAgentApplication.adjustingClaims == true || insuranceAgentApplication.adjustingClaims === 'true'"
                        name="adjustingClaimsRevenue"
                        v-model="insuranceAgentApplication.adjustingClaimsRevenue"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 20px;">
                <div class="col-md-9 col-sm-12">
                  <div class="row" v-if="insuranceAgentApplication.otherBusinessThanInsurance == true || insuranceAgentApplication.otherBusinessThanInsurance === 'true'">
                    <div class="col-md-9 col-sm-12">
                      <label for class="orep-label">
                        Registered Investment Advisor:
                      </label>
                    </div>
                    <div class="col-md-3 d-flex flex-column">
                      <div class="d-flex flex-row">
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="registeredInvestment"
                                value="true"
                                class="orep-radio"
                                v-validate="'required'"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.registeredInvestment"
                            >
                            <span class="radio-span">Yes</span>
                          </label>
                        </div>
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="registeredInvestment"
                                value="false"
                                class="orep-radio"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.registeredInvestment"
                            >
                            <span class="radio-span">No</span>
                          </label>
                        </div>
                      </div>
                      <span
                          v-show="errors.has('registeredInvestment')"
                          class="help is-danger form-errors text-danger"
                      >{{ errors.first('registeredInvestment') | filterText }}</span>
                    </div>
                  </div>
                  <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.registeredInvestment == true || insuranceAgentApplication.registeredInvestment === 'true'">
                    <label class="orep-label text-danger">If Yes: Revenue:
                    </label>

                    <input
                        type="text"
                        placeholder="Please explain:"
                        class="orep-text-input js-orep-input"
                        v-if="insuranceAgentApplication.registeredInvestment == true || insuranceAgentApplication.registeredInvestment === 'true'"
                        name="registeredInvestmentRevenue"
                        v-model="insuranceAgentApplication.registeredInvestmentRevenue"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 20px;">
                <div class="col-md-9 col-sm-12">
                  <div class="row" v-if="insuranceAgentApplication.otherBusinessThanInsurance == true || insuranceAgentApplication.otherBusinessThanInsurance === 'true'">
                    <div class="col-md-9 col-sm-12">
                      <label for class="orep-label">
                        Other Services:
                      </label>
                    </div>
                    <div class="col-md-3 d-flex flex-column">
                      <div class="d-flex flex-row">
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="engagedOtherServices"
                                value="true"
                                class="orep-radio"
                                v-validate="'required'"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.engagedOtherServices"
                            >
                            <span class="radio-span">Yes</span>
                          </label>
                        </div>
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                                type="radio"
                                name="engagedOtherServices"
                                value="false"
                                class="orep-radio"
                                @change="validateBeforeSubmit()"
                                v-model="insuranceAgentApplication.engagedOtherServices"
                            >
                            <span class="radio-span">No</span>
                          </label>
                        </div>
                      </div>
                      <span
                          v-show="errors.has('engagedOtherServices')"
                          class="help is-danger form-errors text-danger"
                      >{{ errors.first('engagedOtherServices') | filterText }}</span>
                    </div>
                  </div>
                  <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.engagedOtherServices == true || insuranceAgentApplication.engagedOtherServices === 'true'">
                    <label class="orep-label text-danger">If Yes: Please List Services:
                    </label>

                    <input
                        type="text"
                        placeholder="Please explain:"
                        class="orep-text-input js-orep-input"
                        v-if="insuranceAgentApplication.engagedOtherServices == true || insuranceAgentApplication.engagedOtherServices === 'true'"
                        name="engagedOtherServicesRevenue"
                        v-model="insuranceAgentApplication.engagedOtherServicesRevenue"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'ibdpro-insurance-agent-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button @click="prev()" class="pagination-dots"></button>
            <button class="pagination-dots pagination-current"></button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid"
              @click="navigateToNext('ibdpro-insurance-agent-application-3')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid"
              @click="navigateToNext('ibdpro-insurance-agent-application-4')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid"
              @click="navigateToNext('pageTwoIsValid-appraiser-5')">
            </button>
            <button
                class="pagination-dots"
                :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid|| !state.pageFiveIsValid"
                @click="navigateToNext('ibdpro-insurance-agent-application-6')">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageTwoIsValid"
            :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('ibdpro-insurance-agent-application-3')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment/moment";
import Datepicker from "vuejs-datepicker";
import {STATES} from "@/utils/constants";

export default {
  name: "ibdpro-insurance-agent-application-2",
  data() {
    return {
      states: STATES
    };
  },
  computedDates() {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    insuranceAgentApplication() {
      return this.$store.state.insuranceAgentApplication.insuranceAgentApplication;
    },
    state() {
      return this.$store.state.insuranceAgentApplication;
    },
    errorMsg() {
      return this.$store.state.insuranceAgentApplication.errorMsg;
    },

    lastRevenueResidentialSales: {
      get: function() {
        return this.insuranceAgentApplication.lastRevenueResidentialSales || '';
      },
      set: function(val) {
        if (val === ''){
          this.insuranceAgentApplication.lastRevenueResidentialSales = 0;
        }
        else {

          this.insuranceAgentApplication.lastRevenueResidentialSales = val;
        }
      }
    },

    lastNumberResidentialSales: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberResidentialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberResidentialSales = 0;
        } else {

          this.insuranceAgentApplication.lastNumberResidentialSales = val;
        }
      },
    },

    nextRevenueResidentialSales: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueResidentialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueResidentialSales = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueResidentialSales = val;
        }
      },
    },

    nextNumberResidentialSales: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberResidentialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberResidentialSales = 0;
        } else {

          this.insuranceAgentApplication.nextNumberResidentialSales = val;
        }
      },
    },


    lastRevenueResidentialProperty: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueResidentialProperty = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueResidentialProperty = val;
        }
      },
    },

    lastNumberResidentialProperty: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberResidentialProperty = 0;
        } else {

          this.insuranceAgentApplication.lastNumberResidentialProperty = val;
        }
      },
    },

    nextRevenueResidentialProperty: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueResidentialProperty = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueResidentialProperty = val;
        }
      },
    },

    nextNumberResidentialProperty: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberResidentialProperty = 0;
        } else {

          this.insuranceAgentApplication.nextNumberResidentialProperty = val;
        }
      },
    },


    lastRevenueResidentialFarm: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueResidentialFarm = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueResidentialFarm = val;
        }
      },
    },

    lastNumberResidentialFarm: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberResidentialFarm = 0;
        } else {

          this.insuranceAgentApplication.lastNumberResidentialFarm = val;
        }
      },
    },

    nextRevenueResidentialFarm: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueResidentialFarm = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueResidentialFarm = val;
        }
      },
    },

    nextNumberResidentialFarm: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberResidentialFarm = 0;
        } else {

          this.insuranceAgentApplication.nextNumberResidentialFarm = val;
        }
      },
    },


    lastRevenueOwnedResidentialRaw: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueOwnedResidentialRaw = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueOwnedResidentialRaw = val;
        }
      },
    },

    lastNumberOwnedResidentialRaw: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberOwnedResidentialRaw = 0;
        } else {

          this.insuranceAgentApplication.lastNumberOwnedResidentialRaw = val;
        }
      },
    },

    nextRevenueOwnedResidentialRaw: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueOwnedResidentialRaw = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueOwnedResidentialRaw = val;
        }
      },
    },

    nextNumberOwnedResidentialRaw: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberOwnedResidentialRaw = 0;
        } else {

          this.insuranceAgentApplication.nextNumberOwnedResidentialRaw = val;
        }
      },
    },


    lastRevenueOwnedResidentialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueOwnedResidentialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueOwnedResidentialAppraisals = val;
        }
      },
    },

    lastNumberOwnedResidentialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberOwnedResidentialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.lastNumberOwnedResidentialAppraisals = val;
        }
      },
    },

    nextRevenueOwnedResidentialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueOwnedResidentialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueOwnedResidentialAppraisals = val;
        }
      },
    },

    nextNumberOwnedResidentialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberOwnedResidentialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.nextNumberOwnedResidentialAppraisals = val;
        }
      },
    },

    lastRevenueCommercialSales: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueCommercialSales = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueCommercialSales = val;
        }
      },
    },

    lastNumberCommercialSales: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberCommercialSales = 0;
        } else {

          this.insuranceAgentApplication.lastNumberCommercialSales = val;
        }
      },
    },

    nextRevenueCommercialSales: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueCommercialSales = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueCommercialSales = val;
        }
      },
    },

    nextNumberCommercialSales: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberCommercialSales = 0;
        } else {

          this.insuranceAgentApplication.nextNumberCommercialSales = val;
        }
      },
    },

    lastRevenueCommercialProperty: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueCommercialProperty = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueCommercialProperty = val;
        }
      },
    },

    lastNumberCommercialProperty: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberCommercialProperty = 0;
        } else {

          this.insuranceAgentApplication.lastNumberCommercialProperty = val;
        }
      },
    },

    nextRevenueCommercialProperty: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueCommercialProperty = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueCommercialProperty = val;
        }
      },
    },

    nextNumberCommercialProperty: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberCommercialProperty = 0;
        } else {

          this.insuranceAgentApplication.nextNumberCommercialProperty = val;
        }
      },
    },

    lastRevenueCommercialFarm: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueCommercialFarm = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueCommercialFarm = val;
        }
      },
    },

    lastNumberCommercialFarm: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberCommercialFarm = 0;
        } else {

          this.insuranceAgentApplication.lastNumberCommercialFarm = val;
        }
      },
    },

    nextRevenueCommercialFarm: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueCommercialFarm = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueCommercialFarm = val;
        }
      },
    },

    nextNumberCommercialFarm: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberCommercialFarm = 0;
        } else {

          this.insuranceAgentApplication.nextNumberCommercialFarm = val;
        }
      },
    },

    lastRevenueOwnedCommercialRaw: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueOwnedCommercialRaw = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueOwnedCommercialRaw = val;
        }
      },
    },

    lastNumberOwnedCommercialRaw: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberOwnedCommercialRaw = 0;
        } else {

          this.insuranceAgentApplication.lastNumberOwnedCommercialRaw = val;
        }
      },
    },

    nextRevenueOwnedCommercialRaw: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueOwnedCommercialRaw = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueOwnedCommercialRaw = val;
        }
      },
    },

    nextNumberOwnedCommercialRaw: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberOwnedCommercialRaw = 0;
        } else {

          this.insuranceAgentApplication.nextNumberOwnedCommercialRaw = val;
        }
      },
    },



    lastRevenueOwnedCommercialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueOwnedCommercialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueOwnedCommercialAppraisals = val;
        }
      },
    },

    lastNumberOwnedCommercialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberOwnedCommercialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.lastNumberOwnedCommercialAppraisals = val;
        }
      },
    },

    nextRevenueOwnedCommercialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueOwnedCommercialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueOwnedCommercialAppraisals = val;
        }
      },
    },

    nextNumberOwnedCommercialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberOwnedCommercialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.nextNumberOwnedCommercialAppraisals = val;
        }
      },
    },

    lastRevenuePropertyManagement: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenuePropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenuePropertyManagement = 0;
        } else {

          this.insuranceAgentApplication.lastRevenuePropertyManagement = val;
        }
      },
    },
    lastRevenueSalesOfBusiness: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueSalesOfBusiness = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueSalesOfBusiness = val;
        }
      },
    },
    lastRevenueMortgageBrokering: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueMortgageBrokering = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueMortgageBrokering = val;
        }
      },
    },
    lastRevenueRealEstateConsulting: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueRealEstateConsulting = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueRealEstateConsulting = val;
        }
      },
    },
    lastRevenueOther: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueOther = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueOther = val;
        }
      },
    },
    lastNumberPropertyManagement: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberPropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberPropertyManagement = 0;
        } else {

          this.insuranceAgentApplication.lastNumberPropertyManagement = val;
        }
      },
    },
    lastNumberSalesOfBusiness: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberSalesOfBusiness = 0;
        } else {

          this.insuranceAgentApplication.lastNumberSalesOfBusiness = val;
        }
      },
    },
    lastNumberMortgageBrokering: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberMortgageBrokering = 0;
        } else {

          this.insuranceAgentApplication.lastNumberMortgageBrokering = val;
        }
      },
    },
    lastNumberRealEstateConsulting: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberRealEstateConsulting = 0;
        } else {

          this.insuranceAgentApplication.lastNumberRealEstateConsulting = val;
        }
      },
    },
    lastNumberOther: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberOther = 0;
        } else {

          this.insuranceAgentApplication.lastNumberOther = val;
        }
      },
    },
    nextRevenuePropertyManagement: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenuePropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenuePropertyManagement = 0;
        } else {

          this.insuranceAgentApplication.nextRevenuePropertyManagement = val;
        }
      },
    },
    nextRevenueSalesOfBusiness: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueSalesOfBusiness = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueSalesOfBusiness = val;
        }
      },
    },
    nextRevenueMortgageBrokering: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueMortgageBrokering = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueMortgageBrokering = val;
        }
      },
    },
    nextRevenueRealEstateConsulting: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueRealEstateConsulting = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueRealEstateConsulting = val;
        }
      },
    },
    nextRevenueOther: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueOther = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueOther = val;
        }
      },
    },
    nextNumberPropertyManagement: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberPropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberPropertyManagement = 0;
        } else {

          this.insuranceAgentApplication.nextNumberPropertyManagement = val;
        }
      },
    },
    nextNumberSalesOfBusiness: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberSalesOfBusiness = 0;
        } else {

          this.insuranceAgentApplication.nextNumberSalesOfBusiness = val;
        }
      },
    },
    nextNumberMortgageBrokering: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberMortgageBrokering = 0;
        } else {

          this.insuranceAgentApplication.nextNumberMortgageBrokering = val;
        }
      },
    },
    nextNumberRealEstateConsulting: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberRealEstateConsulting = 0;
        } else {

          this.insuranceAgentApplication.nextNumberRealEstateConsulting = val;
        }
      },
    },
    nextNumberOther: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberOther = 0;
        } else {

          this.insuranceAgentApplication.nextNumberOther = val;
        }
      },
    },
    //
    // totalLastRevenue() {
    //   return (
    //     Number(this.totalLastRevenueResidentialAppraisal) +
    //     Number(this.totalLastRevenueCommercialAppraisal) +
    //     Number(this.totalLastRevenueRealEstateSales) +
    //     Number(this.totalLastRevenueOtherServices)
    //   ).toFixed(0);
    // },
    // totalLastNumber() {
    //   return (
    //     Number(this.totalLastNumberResidentialAppraisal) +
    //     Number(this.totalLastNumberCommercialAppraisal) +
    //     Number(this.totalLastNumberRealEstateSales) +
    //     Number(this.totalLastNumberOtherServices)
    //   ).toFixed(0);
    // },
    // totalNextRevenue() {
    //   return (
    //     Number(this.totalNextRevenueResidentialAppraisal) +
    //     Number(this.totalNextRevenueCommercialAppraisal) +
    //     Number(this.totalNextRevenueRealEstateSales) +
    //     Number(this.totalNextRevenueOtherServices)
    //   ).toFixed(0);
    // },
    // totalNextNumber() {
    //   return (
    //     Number(this.totalNextNumberResidentialAppraisal) +
    //     Number(this.totalNextNumberCommercialAppraisal) +
    //     Number(this.totalNextNumberRealEstateSales) +
    //     Number(this.totalNextNumberOtherServices)
    //   ).toFixed(0);
    // }
    lastRevenueAuctioneering: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueAuctioneering = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueAuctioneering = val;
        }
      },
    },
    lastNumberAuctioneering: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberAuctioneering = 0;
        } else {

          this.insuranceAgentApplication.lastNumberAuctioneering = val;
        }
      },
    },
    nextRevenueAuctioneering: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueAuctioneering = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueAuctioneering = val;
        }
      },
    },
    nextNumberAuctioneering: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberAuctioneering = 0;
        } else {

          this.insuranceAgentApplication.nextNumberAuctioneering = val;
        }
      },
    },


    lastRevenueShortTermEscrow: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueShortTermEscrow = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueShortTermEscrow = val;
        }
      },
    },
    lastNumberShortTermEscrow: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberShortTermEscrow = 0;
        } else {

          this.insuranceAgentApplication.lastNumberShortTermEscrow = val;
        }
      },
    },
    nextRevenueShortTermEscrow: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueShortTermEscrow = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueShortTermEscrow = val;
        }
      },
    },
    nextNumberShortTermEscrow: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberShortTermEscrow = 0;
        } else {

          this.insuranceAgentApplication.nextNumberShortTermEscrow = val;
        }
      },
    },

  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    prev() {
      this.$router.push({
        name: "ibdpro-insurance-agent-application-1"
      });
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {

      // this.insuranceAgentApplication.sumOfPeriod =
      //     Number(this.insuranceAgentApplication.periodOne)
          // Number(this.insuranceAgentApplication.periodTwo);

      this.insuranceAgentApplication.comissionRange =
          (Number(this.insuranceAgentApplication.estimateCommissionEarnOne)/Number(this.insuranceAgentApplication.periodOne)) * 100 ;
          // Number(this.insuranceAgentApplication.estimateCommissionEarnTwo);

      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.state.insuranceAgentApplication.realEstateAgentBroker === true){
            this.state.pageTwoIsValid = true;
          }
          else {
          this.state.pageTwoIsValid = false;
          this.validateBeforeSubmit();
          }
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },
  },

  mounted() {
    this.validateBeforeSubmit();
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
  .red-text {
    color: red;
  }
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td:not(:first-child), table th:not(:first-child) {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
